/**
 * Accordion JS
 *
 * @since   1.0.0
 * @package lighting-pros
 */

(function($) {
	$(document).ready(function() {

		if ($('.accordion').length) {

			$('.accordion-button').on('click', function() {
				var accordionContent = $(this).parent().prev();
				accordionContent.toggleClass('accordion-active');

				if (accordionContent.hasClass('accordion-active')) {
					TweenMax.to(accordionContent, 0.3, {height:'auto', ease: Power1.easeOut});
					$(this).html(''+lightingPros.accordionCollapse+' <i class="fas fa-arrow-up"></i>' );
				} else {
					TweenMax.to(accordionContent, 0.3, {height:315, ease: Power1.easeOut});
					$(this).html(''+lightingPros.accordionMore+' <i class="fas fa-arrow-down"></i>');
				}

			});

		}

	}); // document.ready
})(jQuery);
